import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NavRoutesRoutingModule } from './nav-routes-routing.module';
import { AddMainRoutesComponent } from './add-main-routes/add-main-routes.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { NgxSpinnerModule } from 'ngx-spinner';


@NgModule({
  declarations: [
    AddMainRoutesComponent
  ],
  imports: [
    CommonModule,
    NavRoutesRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    NgxDatatableModule,
    PipeModule,
    NgbModule,
    NgSelectModule,
    NgxSpinnerModule,
  ]
})
export class NavRoutesModule { }
